export default {
  title: 'Åbningstider',
  headers: {
    edit_time: 'Rediger tid',
    create_time: 'Opret tid',
  },
  labels: {
    select_all: 'Vælg alle',
    timezone: 'Tidszone',
  },
  fields: {
    selected_days: {
      label: 'Valgte dage',
    },
    opening_time: {
      label: 'Åbningstid',
    },
    closing_time: {
      label: 'Lukketid',
    },
  },
  columns: {
    days: 'Dage',
    time: 'Tid',
  },
  buttons: {
    add_opening_time: 'Tilføj åbningstid',
    add: 'Tilføj',
    cancel: 'Annuller',
    save: 'Gem',
    close: 'Luk',
    delete: 'Slet',
    sync_from_online_shop: 'Synkroniser fra onlineshop',
  },
  projects: {
    online_shop: 'Onlineshop',
    reservations: 'Reservationer',
    storefront: 'Storefront',
    not_set_up: '{{project}} (ikke konfigureret til denne lokation)',
  },
  feedback: {
    missing_info: 'Manglende oplysninger',
  },
  toasts: {
    saving_success: 'Gemt',
    saving_error: 'Kunne ikke gemmes. Gennemgå dine oplysninger, og prøv igen.',
    sync_success: 'Synkroniseret',
    sync_error: 'Åbningstiderne kunne ikke synkroniseres fra onlineshoppen. Prøv igen.',
    hours_required: 'Åbningstider er påkrævet. Rediger i stedet de eksisterende tider',
    not_copied: {
      reservations: {
        not_set_up:
          'Reservationer blev ikke opdateret: reservationer er endnu ikke konfigureret for denne lokation. Fanen Reservationer forklarer hvorfor.',
        not_matched:
          'Reservationer blev ikke opdateret: åbningstiden {{time}} findes ikke der. Tjek åbningstiderne under fanen Reservationer.',
        failed: 'Reservationer kunne ikke opdateres. Brug “Synkroniser fra onlineshop” under fanen Reservationer.',
      },
      storefront: {
        not_set_up: 'Storefront blev ikke opdateret: der blev ikke fundet nogen storefront for denne lokation.',
        not_matched:
          'Storefront blev ikke opdateret: åbningstiden {{time}} findes ikke der. Tjek åbningstiderne under fanen Butik.',
        failed: 'Storefront kunne ikke opdateres. Brug “Synkroniser fra onlineshop” under fanen Butik.',
      },
    },
  },
  modals: {
    timezone: {
      form: {
        timezone: {
          label: 'Tidszone',
        },
      },
      toasts: {
        error: 'Tidszonen kunne ikke opdateres',
      },
    },
  },
};
